export default __webpack_public_path__ + "static/media/ToU.0c355e95.pdf";